import AnvaFinalizePage from '@flows/src/components/flow-finalize/AnvaFinalizePage';
import YellowhiveFinalizePage from '@flows/src/pages/flow-products/YellowhiveFinalization';
import { ErrorBoundary } from '@sentry/react';
import { FC } from 'react';
import { Route, Switch } from 'react-router';

export const FLOWS_FINALIZE_PATH = '/flow-finalize';

const FlowsFinalizeRouter: FC = () => {
  return (
    <ErrorBoundary>
      <Switch>
        <Route
          path={`${FLOWS_FINALIZE_PATH}/anva`}
          component={AnvaFinalizePage}
          exact
        />
        <Route
          path={`${FLOWS_FINALIZE_PATH}/yellowhive`}
          component={YellowhiveFinalizePage}
          exact
        />
      </Switch>
    </ErrorBoundary>
  );
};

export default FlowsFinalizeRouter;
